import { createFileRoute } from "@tanstack/react-router"
import { projectSettingsDetailViewStaticData } from "src/views/ProjectSettingsDetailView/constants"
import { ProjectSettingsDetailView } from "src/views/ProjectSettingsDetailView/ProjectSettingsDetailView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/")({
	component: ProjectSettingsDetailView,
	staticData: projectSettingsDetailViewStaticData,
})
